import { putApiProjectsChangeProjectStatus } from './generated/endpoints/project/project';
import {
  getApiProjectsProjectIdPreworkcontrol,
  getApiProjectsProjectIdPreworkcontrolPdf,
  postApiProjectsProjectIdPreworkcontrolSign,
  putApiProjectsProjectIdPreworkcontrol,
} from './generated/endpoints/pre-work-control/pre-work-control';
import { postApiSharepointArchiveProjectId } from './generated/endpoints/share-point/share-point';
import {
  getApiWorkPreparationCompletionDefinitions,
  getApiWorkPreparationProjectIdReadiness,
  postApiWorkPreparationProjectIdAdvanceStatus,
  postApiWorkPreparationProjectIdSignScaffoldingSelfControl,
  postApiWorkPreparationProjectIdSignWeatherProtectionSelfControl,
} from './generated/endpoints/work-preparation/work-preparation';
import type { KontrollCreateDto } from './generated/model/kontrollCreateDto';
import type { ProjectStatus } from './generated/model/projectStatus';

export const getPreWorkControl = getApiProjectsProjectIdPreworkcontrol;

export const putPreWorkControl = (projectId: number, data: KontrollCreateDto) =>
  putApiProjectsProjectIdPreworkcontrol(projectId, data);

export const signPreWorkControl = postApiProjectsProjectIdPreworkcontrolSign;

export const getPreWorkControlPdf = getApiProjectsProjectIdPreworkcontrolPdf;

export const archiveProject = postApiSharepointArchiveProjectId;

export const getWorkPreparationReadiness = getApiWorkPreparationProjectIdReadiness;

export const advanceWorkPreparationStatus = postApiWorkPreparationProjectIdAdvanceStatus;

export const getWorkPreparationCompletionDefinitions = () =>
  getApiWorkPreparationCompletionDefinitions();

export const signScaffoldingSelfControl = postApiWorkPreparationProjectIdSignScaffoldingSelfControl;

export const signWeatherProtectionSelfControl = postApiWorkPreparationProjectIdSignWeatherProtectionSelfControl;

export const changeProjectStatus = (projectId: number, status: ProjectStatus) =>
  putApiProjectsChangeProjectStatus({ projectId, status });
